import { useState, useEffect } from "react"
import { request } from "source/registrations/api/client"
import {
  createResource,
  useCacheRead,
} from "source/shared/react-cache-but-its-a-context"

const RegistrationsApiResource = createResource(
  (path, { preload = true, ...options }) =>
    preload ? request("get", path, options) : Promise.resolve(null),
  (path, options = {}) =>
    `RegistrationsApiResource-${path}-${JSON.stringify({ options })}`,
)

const useApi = ({ path: initialPath, data: initialData = {} }) => {
  const [loading, setLoading] = useState(initialPath ? true : false)
  const [errors, setErrors] = useState(null)
  const [response, setResponse] = useState({ data: null, meta: null })

  const cacheResource = useCacheRead(
    RegistrationsApiResource,
    initialPath,
    initialData,
  )

  useEffect(() => {
    if (!cacheResource) return
    handleResponse(cacheResource)
  }, [cacheResource])

  const handleResponse = (apiResponse) => {
    if (apiResponse.data) {
      setResponse(apiResponse)
    } else {
      setErrors(apiResponse.errors)
    }

    setLoading(false)
  }

  const handleRequest = async (
    method,
    { path = initialPath, id = null, data = {} },
  ) => {
    setLoading(true)
    setErrors(null)

    const requestPath = id ? `${path}/${id}` : path

    const apiResponse = await request(method, requestPath, {
      ...initialData,
      ...data,
    })

    handleResponse(apiResponse)

    return apiResponse
  }

  const post = async ({ path, ...data }) =>
    handleRequest("post", { path, data })
  const get = async ({ path, id, ...data }) =>
    handleRequest("get", { id, path, data })
  const patch = async ({ path, id, ...data }) =>
    handleRequest("patch", { id, path, data })
  const put = async ({ path, id, ...data }) =>
    handleRequest("put", { id, path, data })
  const destroy = async ({ path, id, ...data }) =>
    handleRequest("del", { id, path, data })

  return {
    loading,
    errors,
    data: response.data,
    meta: response.meta,
    get,
    patch,
    put,
    destroy,
    post,
  }
}

export default useApi
